<template>
    <v-container>
        <v-row align="center" justify="center">
       
      
            <v-img
            :src="require('../assets/bedsheet.jpeg')"
            class="my-3"
            
            height="300"
            width="600"
            ></v-img>
       

        </v-row>
        <v-layout align-center>
            <v-flex xs12>
                <div align="center" class="primary--text">
                <h4>Please Visit our shop at</h4><br />
                <h4>BIJOY TEXTILES 34, NEW MARKET, FANCY BAZAR, GUWAHATI -781001</h4>
                <h3>@ 0361-2635115</h3>
                <h3>-- Our Products --</h3>
                <h3>Bed Sheets</h3>
                <h3>Curtains</h3>
                <h3>Blankets</h3>
                <h3>Mosquito Nets</h3>
                <h3>Cushion Cover</h3>
                <h3>Verticals/ roller Blinds</h3>

                </div>
            </v-flex>
        </v-layout>
        <!--
        <v-btn to='/product_category/new'>New Product Category</v-btn>
        <v-btn to='/grouphead'>Group Head</v-btn>
        <v-btn to='/product_category/new'>Group List</v-btn>
        <v-btn to='/ledger/new'>Ledger</v-btn>
        <v-btn to='/cashpos'>Bill</v-btn> -->
        
    </v-container>

</template>

<script>
export default {

}
</script>

<style>

</style>
